!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactDice = t(require("react")) : e.ReactDice = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.i = function (e) {
      return e;
    }, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = "./src/ReactDice.js");
  }({
    "./node_modules/prop-types/factoryWithThrowingShims.js": function node_modulesPropTypesFactoryWithThrowingShimsJs(e, t, r) {
      "use strict";

      function n() {}

      var o = r("./node_modules/prop-types/lib/ReactPropTypesSecret.js");

      e.exports = function () {
        function e(e, t, r, n, s, i) {
          if (i !== o) {
            var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw a.name = "Invariant Violation", a;
          }
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var r = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t
        };
        return r.checkPropTypes = n, r.PropTypes = r, r;
      };
    },
    "./node_modules/prop-types/index.js": function node_modulesPropTypesIndexJs(e, t, r) {
      e.exports = r("./node_modules/prop-types/factoryWithThrowingShims.js")();
    },
    "./node_modules/prop-types/lib/ReactPropTypesSecret.js": function node_modulesPropTypesLibReactPropTypesSecretJs(e, t, r) {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    "./src/DiceContainer.js": function srcDiceContainerJs(e, t, r) {
      "use strict";

      function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function o(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      var i = r(0),
          a = r.n(i),
          l = r("./src/Die.js"),
          c = r("./src/styles.scss"),
          p = (r.n(c), Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }),
          u = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
          f = function (e) {
        function t(e) {
          n(this, t);
          var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return r.state = {
            totalValue: 6 * e.numDice
          }, r.dice = [], r.rollCount = 0, r.rollDone = r.rollDone.bind(r), r.rollAll = r.rollAll.bind(r), r.getDiceTotal = r.getDiceTotal.bind(r), r;
        }

        return s(t, e), u(t, [{
          key: "rollAll",
          value: function value(e) {
            this.rollCount = 0;
            var t = 0,
                r = !0,
                n = !1,
                o = void 0;

            try {
              for (var s, i = this.dice[Symbol.iterator](); !(r = (s = i.next()).done); r = !0) {
                var a = s.value;
                null !== a && (this.rollCount++, a.rollDie(e[t]), t++);
              }
            } catch (e) {
              n = !0, o = e;
            } finally {
              try {
                !r && i.return && i.return();
              } finally {
                if (n) throw o;
              }
            }
          }
        }, {
          key: "rollDone",
          value: function value() {
            --this.rollCount <= 0 && this.getDiceTotal();
          }
        }, {
          key: "getDiceTotal",
          value: function value() {
            var e = 0,
                t = !0,
                r = !1,
                n = void 0;

            try {
              for (var o, s = this.dice[Symbol.iterator](); !(t = (o = s.next()).done); t = !0) {
                var i = o.value;
                null !== i && (e += i.getValue());
              }
            } catch (e) {
              r = !0, n = e;
            } finally {
              try {
                !t && s.return && s.return();
              } finally {
                if (r) throw n;
              }
            }

            this.setState({
              totalValue: e
            }), this.props.totalCb(e);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e, t) {
            e.numDice !== this.props.numDice && this.getDiceTotal();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = this.props,
                r = [];
            this.dice.splice(t.numDice, 100 - t.numDice);

            for (var n = 0; n < t.numDice; n++) {
              !function (n) {
                r.push(a.a.createElement(l.a, p({}, t, {
                  key: n,
                  rollDone: e.rollDone,
                  ref: function ref(t) {
                    return e.dice[n] = t;
                  }
                })));
              }(n);
            }

            return a.a.createElement("div", {
              className: "dice"
            }, r);
          }
        }]), t;
      }(i.Component),
          d = f;

      t.a = d;
      !function () {
        "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(f, "DiceContainer", "/Users/domas/Developer/react-dice-complete/src/DiceContainer.js"), __REACT_HOT_LOADER__.register(d, "default", "/Users/domas/Developer/react-dice-complete/src/DiceContainer.js"));
      }();
    },
    "./src/Die.js": function srcDieJs(e, t, r) {
      "use strict";

      function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function o(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      var i = r(0),
          a = r.n(i),
          l = r("./node_modules/prop-types/index.js"),
          c = (r.n(l), function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }()),
          p = function (e) {
        function t(e) {
          n(this, t);
          var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return r.state = {
            currentValue: 6
          }, r.rollDie = r.rollDie.bind(r), r;
        }

        return s(t, e), c(t, [{
          key: "getRandomInt",
          value: function value() {
            var e = Math.ceil(this.props.sides);
            return Math.floor(Math.random() * e) + 1;
          }
        }, {
          key: "rollDie",
          value: function value(e) {
            var t = this;
            this.die.className = "die", this.die.offsetWidth;
            var r = e || this.getRandomInt();
            this.die.classList.add("roll" + r), setTimeout(function () {
              t.setState({
                currentValue: r
              }), t.props.rollDone(r);
            }, 1e3 * this.props.rollTime);
          }
        }, {
          key: "getValue",
          value: function value() {
            return this.state.currentValue;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = {
              background: this.props.faceColor,
              outline: this.props.outline ? "1px solid " + this.props.outlineColor : "none",
              height: this.props.dieSize + "px",
              position: "absolute",
              width: this.props.dieSize + "px"
            },
                r = {
              transform: "rotateX(180deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                n = {
              transform: "rotateY(-90deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                o = {
              transform: "rotateX(90deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                s = {
              transform: "rotateX(-90deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                i = {
              transform: "rotateY(90deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                l = {
              transform: "rotateY(0deg) translateZ(" + this.props.dieSize / 2 + "px)"
            },
                c = this.props.dieSize / 6 - 2,
                p = {
              background: this.props.dotColor,
              height: c + "px",
              width: c + "px"
            },
                u = {
              top: this.props.dieSize / 6 + "px",
              left: this.props.dieSize / 6 + "px"
            },
                f = {
              top: this.props.dieSize / 6 + "px",
              right: this.props.dieSize / 6 + "px"
            },
                d = {
              top: this.props.dieSize / 2 - c / 2 + "px",
              left: this.props.dieSize / 6 + "px"
            },
                m = {
              top: this.props.dieSize / 2 - c / 2 + "px",
              left: this.props.dieSize / 2 - c / 2 + "px"
            },
                y = {
              top: this.props.dieSize / 2 - c / 2 + "px",
              right: this.props.dieSize / 6 + "px"
            },
                h = {
              bottom: this.props.dieSize / 6 + "px",
              left: this.props.dieSize / 6 + "px"
            },
                b = {
              bottom: this.props.dieSize / 6 + "px",
              right: this.props.dieSize / 6 + "px"
            },
                _ = {
              animationDuration: this.props.rollTime + "s",
              height: this.props.dieSize + "px",
              width: this.props.dieSize + "px"
            },
                O = {
              margin: this.props.margin + "px",
              display: "inline-block"
            };
            return a.a.createElement("div", {
              className: "die-container",
              onClick: this.props.disableIndividual ? null : function () {
                return e.rollDie();
              },
              style: O
            }, a.a.createElement("div", {
              className: "die",
              ref: function ref(t) {
                return e.die = t;
              },
              style: _
            }, a.a.createElement("div", {
              className: "face six",
              style: Object.assign({}, t, l)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, u)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, f)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, d)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, y)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, h)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, b)
            })), a.a.createElement("div", {
              className: "face one",
              style: Object.assign({}, t, r)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, m)
            })), a.a.createElement("div", {
              className: "face five",
              style: Object.assign({}, t, i)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, u)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, f)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, m)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, h)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, b)
            })), a.a.createElement("div", {
              className: "face two",
              style: Object.assign({}, t, n)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, f)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, h)
            })), a.a.createElement("div", {
              className: "face three",
              style: Object.assign({}, t, o)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, f)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, m)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, h)
            })), a.a.createElement("div", {
              className: "face four",
              style: Object.assign({}, t, s)
            }, a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, u)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, f)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, h)
            }), a.a.createElement("span", {
              className: "dot",
              style: Object.assign({}, p, b)
            }))));
          }
        }]), t;
      }(i.Component),
          u = p;

      t.a = u;
      !function () {
        "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(p, "Die", "/Users/domas/Developer/react-dice-complete/src/Die.js"), __REACT_HOT_LOADER__.register(u, "default", "/Users/domas/Developer/react-dice-complete/src/Die.js"));
      }();
    },
    "./src/ReactDice.js": function srcReactDiceJs(e, t, r) {
      "use strict";

      function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function o(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = r(0),
          a = r.n(i),
          l = r("./node_modules/prop-types/index.js"),
          c = (r.n(l), r("./src/DiceContainer.js")),
          p = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      },
          u = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
          f = function (e) {
        function t(e) {
          n(this, t);
          var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return r.totalCb = r.totalCb.bind(r), r.rollAll = r.rollAll.bind(r), r;
        }

        return s(t, e), u(t, [{
          key: "totalCb",
          value: function value(e) {
            this.props.rollDone(e);
          }
        }, {
          key: "rollAll",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            this.diceContainer.rollAll(e);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this;
            return a.a.createElement("div", null, a.a.createElement(c.a, p({}, this.props, {
              totalCb: this.totalCb,
              ref: function ref(t) {
                return e.diceContainer = t;
              }
            })));
          }
        }]), t;
      }(i.Component);

      f.propTypes = {
        outline: l.PropTypes.bool,
        outlineColor: l.PropTypes.string,
        dieSize: l.PropTypes.number,
        disableIndividual: l.PropTypes.bool,
        margin: l.PropTypes.number,
        numDice: l.PropTypes.number,
        sides: l.PropTypes.number,
        rollTime: l.PropTypes.number,
        rollDone: l.PropTypes.func,
        faceColor: l.PropTypes.string,
        dotColor: l.PropTypes.string
      }, f.defaultProps = {
        outline: !1,
        outlineColor: "#000000",
        dieSize: 60,
        disableIndividual: !1,
        margin: 15,
        numDice: 4,
        sides: 6,
        rollTime: 2,
        faceColor: "#FF00AC",
        dotColor: "#1dff00"
      };
      var d = f;
      t.default = d;
      !function () {
        "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(f, "ReactDice", "/Users/domas/Developer/react-dice-complete/src/ReactDice.js"), __REACT_HOT_LOADER__.register(d, "default", "/Users/domas/Developer/react-dice-complete/src/ReactDice.js"));
      }();
    },
    "./src/styles.scss": function srcStylesScss(e, t) {},
    0: function _(t, r) {
      t.exports = e;
    }
  });
});